import React, { useState } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import styled from "styled-components";

const Logo = styled.img`
    margin-right: 20px;
    height: 3rem;
`;

const AppLogo = ({src}) => (
    <Logo src={src}/>
);

const mapStateToProps = (state, ownProps) => {
    return {
    };
};

const mapDispatchToProps = {
};

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(AppLogo));